import { createAction } from 'typesafe-actions';

export const clearRequest = createAction(
  'request/clearRequest',
  (resolve) => (actionUid: string) => resolve({ actionUid })
);
